Ext.ns('mx.app.widget');

mx.app.widget.CoreEventsManager = Ext.extend(mx.comp.NonVisual, {
    labels: {
        scheduling: 'Scheduling',
        schedulingStarted: 'Scheduling started',
        schedulingFinished: 'Scheduling finished',
        schedulingError: 'Scheduling error',
    },
    channels: ['lifecycle', 'scheduler', 'scheduler_match', 'export_finished'],
    //config
    updateHandler: null,
    eventsFilter: null, //for distinguishing events demanding UI update
    updatePeriod: null,
    //state logic variables
    paused: false, //indicates parent component switched off UI refreshes
    uiNeedsRefresh: null, //indicates events arrived after last timer tick which demand UI refresh
    updatedRecently: false, //indicates UI was updated at last timer tick
    //other state variables
    timerHandle: null,
    scopedEventHandler: null,
    onEvent: null,

    needShowEventPopup: function(event) {
        return event.type == 'LIFECYCLE' && event.body.description != 'Trigger committing';
    },
    initComponent: function() {
        mx.Util.ServerEvents.reset();
        if (this.eventsHandler) {
            this.scopedEventHandler = this.eventsHandler.createDelegate(this);
            this.channels.forEach(function(channel) {
                mx.Util.ServerEvents.bind('/server/' + channel, this.scopedEventHandler);
            }, this);
        }

        this.planNextUpdate();

        this.on('beforedestroy', this.unbind, this);
    },
    clickCallback: Ext.emptyFn,
    processAlert: function(alertMessage) {
        return alertMessage;
    },
    eventsHandler: function(event) {
        this.uiNeedsRefresh |= this.eventsFilter ? this.eventsFilter(event) : false;
        if (event.body.alertMessages && event.body.alertMessages.length != 0) {
            for (var i = 0; i < event.body.alertMessages.length; ++i) {
                var message = event.body.alertMessages[i];
                event.body.alertMessages[i] = new mx.data.Alert(Ext.apply(message, this.processAlert(message, true)));
            }
        }
        if (this.needShowEventPopup(event)) {
            if (event.body.alertMessages && event.body.alertMessages.length != 0) {
                for (i = 0; i < event.body.alertMessages.length; ++i) {
                    //var uiMessage = this.processAlertMessage(event.body.alertMessages[i]);
                    var uiMessage = event.body.alertMessages[i].data;
                    var record = event.body.alertMessages[i];
                    var thiz = this;
                    mx.Util.Notifications.notify({
                        title: uiMessage.title,
                        message: uiMessage.message,
                        clickCallback: function() {
                            thiz.clickCallback(this, event, record);
                        },
                    });
                }
            }
        } else if (event.type == 'SCHEDULER') {
            if (event.body.automaticPlanning && !application.schedulingInProgress) {
                var reason = null;
                var isError = false;
                if (event.body.status == 'start') {
                    reason = event.body.log ? event.body.log : this.labels.schedulingStarted;
                } else if (event.body.status == 'end') {
                    reason = event.body.log ? event.body.log : this.labels.schedulingFinished;
                } else if (event.body.status == 'error') {
                    reason = event.body.log ? event.body.log : this.labels.schedulingError;
                    isError = true;
                }
                if (reason) {
                    mx.Util.Notifications.notify({title: this.labels.scheduling, message: reason, isError: isError});
                }
            }
        }
        if (this.uiNeedsRefresh && !this.updatedRecently) {
            clearTimeout(this.timerHandle);
            this.update();
        }
        if (!event.stopEvent) {
            mx.Util.ServerEvents.confirm(event.id);
        } else {
            mx.Util.ServerEvents.defer(event.id);
        }

        if (this.onEvent) {
            this.onEvent(event);
        }
    },
    update: function() {
        this.timerHandle = null;
        this.updatedRecently = !this.paused && this.uiNeedsRefresh;
        if (this.updatedRecently) {
            this.uiNeedsRefresh = false;
            if (this.updateHandler) {
                try {
                    this.updateHandler(this.planNextUpdate.createDelegate(this));
                } catch (e) {
                    console.log('Error while updating UI on event: ' + e);
                    this.planNextUpdate();
                }
            }
        } else {
            this.planNextUpdate();
        }
    },
    planNextUpdate: function() {
        this.timerHandle = this.update.defer(this.updatePeriod * 1000, this);
    },
    unbind: function() {
        if (this.scopedEventHandler) {
            this.channels.forEach(function(channel) {
                mx.Util.ServerEvents.unbind('/server/' + channel, this.scopedEventHandler);
            }, this);
        }
        if (this.timerHandle) {
            clearTimeout(this.timerHandle);
        }
    },
});
